module.exports = __webpack_public_path__ + "static/img/bg8.5a30fb8e.png";